import React, { useContext } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import ServiceMatrixContext from '@totem/components/portfolio/serviceMatrix/ServiceMatrixContext';
import { buildingDisplayName } from '@totem/components/ui_components/constants';

const styles = {
  searchContainer: {
    marginBottom: '0.5rem',
  },
  search: {
    width: '240px',
  },
};

const ServiceMatrixFilters = () => {
  const { searchText, setSearchText } = useContext(ServiceMatrixContext);

  return (
    <div style={styles.searchContainer}>
      <Input
        prefix={<SearchOutlined />}
        placeholder={`Search ${buildingDisplayName.toLowerCase()}...`}
        style={styles.search}
        value={searchText}
        onChange={(evt) => setSearchText(evt.target.value)}
        allowClear
      />
    </div>
  );
};

export default ServiceMatrixFilters;
